import React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import Section from '../components/Section';
import ContactForm from '../components/ContactForm';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';

const ContactContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  
  @media (min-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const ContactInfo = styled.div`
  margin-bottom: 2rem;
`;

const ContactTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 1.5rem;
`;

const ContactDescription = styled.p`
  margin-bottom: 2rem;
  color: var(--gray);
  font-size: 1.1rem;
`;

const ContactMethods = styled.div`
  margin-bottom: 2rem;
`;

const ContactMethodItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
  font-size: 1.1rem;
  
  svg {
    width: 24px;
    height: 24px;
    color: var(--blue);
    margin-right: 1rem;
  }
  
  a {
    color: var(--gray-dark);
    text-decoration: none;
    transition: color 0.2s ease;
    
    &:hover {
      color: var(--blue);
    }
  }
`;

const ContactHours = styled.div`
  background-color: #f8f9fa;
  padding: 1.5rem;
  border-radius: var(--border-radius);
  margin-bottom: 2rem;
`;

const ContactHoursTitle = styled.h3`
  font-size: 1.25rem;
  margin-bottom: 1rem;
`;

const HoursList = styled.ul`
  list-style: none;
  padding: 0;
`;

const HoursItem = styled.li`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  
  .day {
    font-weight: 500;
  }
`;

const ContactMap = styled.div`
  margin-top: 2rem;
  height: 300px;
  border-radius: var(--border-radius);
  overflow: hidden;
  
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const ContactoPage = () => {
  return (
    <Layout>
      <SEO 
        title="Contacto | Solicita Presupuesto para tu Web" 
        description="Contacta con nuestro equipo para solicitar un presupuesto personalizado para tu página web económica. Respondemos en menos de 24 horas." 
        keywords="contacto web barata, presupuesto página web, solicitar diseño web económico"
        canonical="https://webabajocoste.es/contacto"
      />
      
      <Section
        title="Contacta con nosotros"
        subtitle="Estaremos encantados de asesorarte y ofrecerte la mejor solución para tu proyecto web"
        background="light"
        centered
      >
        <ContactContainer>
          <ContactInfo>
            <ContactTitle>Estamos aquí para ayudarte</ContactTitle>
            <ContactDescription>
              Ya sea que necesites un presupuesto, tengas dudas sobre nuestros servicios o quieras saber más 
              sobre cómo podemos ayudarte, nuestro equipo está a tu disposición para atenderte.
            </ContactDescription>
            
            <ContactMethods>
              <ContactMethodItem>
                <FaPhone />
                <a href="tel:+34628774688">+34 628 774 688</a>
              </ContactMethodItem>
              
              <ContactMethodItem>
                <FaWhatsapp />
                <a href="https://wa.me/34628774688" target="_blank" rel="noreferrer">
                  WhatsApp: +34 628 774 688
                </a>
              </ContactMethodItem>
              
              <ContactMethodItem>
                <FaEnvelope />
                <a href="mailto:hola@webabajocoste.es">hola@webabajocoste.es</a>
              </ContactMethodItem>
              
              <ContactMethodItem>
                <FaMapMarkerAlt />
                <span>Calle Merced 20 1C, Guadalajara 19001</span>
              </ContactMethodItem>
            </ContactMethods>
            
            <ContactHours>
              <ContactHoursTitle>Horario de atención</ContactHoursTitle>
              <HoursList>
                <HoursItem>
                  <span className="day">Lunes a Viernes</span>
                  <span>9:00 - 18:00</span>
                </HoursItem>
                <HoursItem>
                  <span className="day">Sábados</span>
                  <span>10:00 - 14:00</span>
                </HoursItem>
                <HoursItem>
                  <span className="day">Domingos y festivos</span>
                  <span>Cerrado</span>
                </HoursItem>
              </HoursList>
            </ContactHours>
            
            <ContactMap>
              <iframe 
                title="Ubicación de Web a Bajo Coste"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3033.2904243853235!2d-3.1659942839525043!3d40.6322!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd43ac9ea39902e3%3A0x9f0d5f0a5759589!2sC.%20Merced%2C%2020%2C%2019001%20Guadalajara!5e0!3m2!1ses!2ses!4v1652269625580!5m2!1ses!2ses"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </ContactMap>
          </ContactInfo>
          
          <ContactForm 
            formspreeEndpoint="https://formspree.io/f/your-endpoint" 
          />
        </ContactContainer>
      </Section>
    </Layout>
  );
};

export default ContactoPage; 